import { Dialog, DialogPanel } from "@headlessui/react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQueryClient } from "@tanstack/react-query";

export default NiceModal.create(({ queryClient, project }) => {
  const modal = useModal();
  async function handleSubmit(evt) {
    evt.preventDefault();
    let data = Object.fromEntries(new FormData(evt.target));
    let url, method;
    if (project) {
      url = `${evt.target.action}/${project.id}`;
      method = "PUT";
    } else {
      url = evt.target.action;
      method = "POST";
    }
    let resp = await fetch(url, {
      method: method,
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (resp.ok) {
      queryClient.invalidateQueries({
        queryKey: ["projects"],
      });
      modal.remove();
    }
  }
  async function handleDeleteButtonClick() {
    if (
      window.confirm(
        "Wirklich löschen? Alle Daten des Projekts gehen verloren!"
      )
    ) {
      fetch(`/api/admin/project/${project.id}`, {
        method: "DELETE",
      }).then(() => {
        queryClient.invalidateQueries({
          queryKey: ["projects"],
        });
        modal.remove();
      });
    }
  }
  return (
    <Dialog
      open={modal.visible}
      onClose={() => {
        modal.remove();
      }}
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel>
            <div
              className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl sm:p-6"
              id="adduse-modal-panel"
            >
              <div>
                <form
                  className="mt-8 space-y-6"
                  action="/api/admin/project"
                  method="POST"
                  onSubmit={handleSubmit}
                >
                  <div className="-space-y-px rounded-md shadow-sm">
                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                      <div className="col-span-6">
                        <label htmlFor="project_name">Name des Projekts*</label>
                        <input
                          id="project_name"
                          name="name"
                          type="text"
                          minlength="1"
                          required
                          defaultValue={project?.name}
                          className="relative block w-full appearance-none rounded--md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-stone-500 focus:outline-none focus:ring-stone-500 sm:text-sm"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="space-y-1">
                    <button
                      type="submit"
                      className="group relative flex w-full justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white hover:bg-stone-700 focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2"
                    >
                      Speichern
                    </button>
                    <button
                      type="button"
                      onClick={() => modal.remove()}
                      className="group relative flex w-full justify-center rounded-md border border-transparent bg-red-800 py-2 px-4 text-sm font-medium text-white hover:bg-stone-700 focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2"
                    >
                      Abbrechen
                    </button>
                    {project && (
                      <button
                        type="button"
                        onClick={handleDeleteButtonClick}
                        className="text-xs text-red-600 underline justify-center hover:text-red-800"
                      >
                        Projekt löschen
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
});
